import { API } from "config/api";
import { API_ROUTES } from "config/apiRoutes";
import { downloadFile } from "utils/downloads";

function filenameFromContentDisposition(
  header: string | undefined,
  fallback: string
): string {
  if (!header) return fallback;
  const match = /filename="?([^"]+)"?/i.exec(header);
  return match?.[1] || fallback;
}

/**
 * Downloads a single-student education-record JSON package (FERPA inspect).
 */
export async function downloadStudentEducationRecords(
  userId: string
): Promise<void> {
  const response = await API.get(
    API_ROUTES.USERS.EDUCATION_RECORDS_EXPORT(userId),
    { responseType: "text" }
  );
  const filename = filenameFromContentDisposition(
    response.headers["content-disposition"],
    `vetnebula-education-records-${userId}.json`
  );
  const body =
    typeof response.data === "string"
      ? response.data
      : JSON.stringify(response.data, null, 2);
  downloadFile(body, filename, "application/json");
}
